module.exports = __webpack_public_path__ + "static/media/01_design_pao-insight.fa8e2d09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/01_design_pao-insight.jpg
// module id = 237
// module chunks = 0